/* share social */
$(function() {
    $(document).ready(function() {
        const toggle = $('.socialShareToggle');
        const copyUrlButton = toggle.closest('.banner-share-wrap').find('.__copy');
        const copyUrl = $(location).attr('href');
        const temp = $("<input>");

        toggle.click(function() {
            event.preventDefault();
            $(this)
                .siblings('.socialShareContent')
                .toggleClass('__active');
        });
        
        const setElementText = function(element, text, speed) {
            setTimeout(function() {
                element.text(`${text}`)
            }, speed);
        }

        // copy url
        copyUrlButton.click(function() {
            $("body").append(temp);
            temp.val(copyUrl).select();
            document.execCommand("copy");
            temp.remove();
            $(this).text('URL copied');
            setElementText($(this), 'Copy link', 3000);
        });

        // close social share when clicking on the body
        $(document).click(function(e) {
            const target = e.target;
            const bannerShare = target.closest('.__links');

            if (!bannerShare) {
                toggle
                    .siblings('.socialShareContent')
                    .removeClass('__active');
            }
        })
    })
});
